import { Rnd } from "react-rnd";
import { useState, useEffect } from "react";

export default function DraggablePanel({
  title,
  children,
  defaultSize = { width: 550, height: 650 },
  size,
  defaultPosition = { x: 100, y: 100 },
  onClose,
  onResizeStop,
  onDragStop,
  collapsed
}) {
  const [position, setPosition] = useState(() => defaultPosition);

  return (
    <Rnd
      position={position}
      onDragStop={(e, d) => {
        setPosition({ x: d.x, y: d.y });
        onDragStop && onDragStop(e, d);
      }}
      size={size}
      onResizeStop={onResizeStop}
      minWidth={200}
      minHeight={40}
      bounds="window"
      dragHandleClassName="drag-handle"
      enableResizing={!collapsed}
      cancel=".no-drag"
      style={{
        zIndex: 100,
        pointerEvents: "auto",
        background: "#111",
        borderRadius: 10,
        overflow: "hidden", // 🔥 important for canvas clipping
        boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
        transition: "height 0.15s ease"
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        {/* HEADER */}
        <div
          className="drag-handle"
          onDoubleClick={onClose}
          style={{
            height: 32,
            background: "#222",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 10px",
            cursor: "move",
            fontSize: 13,
            fontWeight: 600,
            userSelect: "none",
            flexShrink: 0
          }}
        >
          <span>{title}</span>

          {onClose && (
            <button
              className="no-drag"
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                cursor: "pointer",
                fontSize: 16,
                fontWeight: "bold"
              }}
            >
              {collapsed ? "⬆" : "—"}
            </button>
          )}
        </div>

        {/* CONTENT */}
        <div
          className="no-drag"
          style={{
            flex: 1,
            overflow: "auto", // 🔥 will be overridden when drawing
            padding: 10,
            color: "white",
            minHeight: 0,
            position: "relative" // 🔥 CRITICAL for drawing overlay
          }}
        >
          {children}
        </div>
      </div>
    </Rnd>
  );
}